const DEFAULT_SALES_MARKET_LANG = 'pl';

export default DEFAULT_SALES_MARKET_LANG;
